import { render, staticRenderFns } from "./qrElementOptions.vue?vue&type=template&id=1ddcaa6f&scoped=true&"
import script from "./qrElementOptions.vue?vue&type=script&lang=js&"
export * from "./qrElementOptions.vue?vue&type=script&lang=js&"
import style0 from "./qrElementOptions.vue?vue&type=style&index=0&id=1ddcaa6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddcaa6f",
  null
  
)

export default component.exports